<template>
  <div @click.stop="handleClick">
    <input
      :accept="getAccept"
      :multiple="multiple"
      @change="handleChange"
      class="input-style"
      ref="input"
      type="file">
    <slot name="tip"></slot>
  </div>
</template>


<script>
const uuidv1 = require('uuid/v1')
import {
  fileOnlineOssInfo,
  fileUnderlineOssInfo,
  isOnLine,
  onlineOssInfo,
  projectName,
  underlineOssInfo,
  videoOnlineOssInfo,
  videoUnderlineOssInfo
} from '../../config/constantconfig'
import ossupload from '../../utils/fileossupload'

export default {
  name: 'FileTypeUpload',
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: true
    },
    prefix: {
      type: String,
      default: 'common/desc/'
    },
    videoprefix: {
      type: String,
      default: 'common/desc/'
    },
    uploadType: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {}
  },
  computed: {
    getAccept () {
      let type = ''
      switch (this.uploadType) {
        case 1:
          type = 'image/*'
          break
        case 2:
          type = 'video/*'
          break
        case 3:
          type = 'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          break
        case 4:
          type = 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.spreadsheetml.template,application/vnd.ms-excel.addin.macroEnabled.12'
          break
        case 5:
          type = 'application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation'
          break
        case 6:
          type = 'application/pdf'
          break
        case 7:
          type = 'image/*,video/*'
          break
        case 8:
          type = 'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.spreadsheetml.template,application/vnd.ms-excel.addin.macroEnabled.12,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/pdf'
          break
        default:
          type = 'image/*'
          break
      }
      return type
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    /**
     * 判断是否可上传状态
     */
    handleClick () {
      if (!this.clickable) {
        return
      }
      this.$refs.input.click()
    },
    /**
     * 解析选择上传文件
     * @param e
     */
    handleChange (e) {
      const files = e.target.files
      if (!files) {
        return
      }
      this.uploadFiles(files)
      this.$refs.input.value = null
    },
    async uploadFiles (files) {
      let postFiles = Array.prototype.slice.call(files)
      if (postFiles.length === 0) return
      if (!this.multiple) postFiles = postFiles.slice(0, 1)
      let resultArray = []
      for (let i = 0; i < postFiles.length; i++) {
        let file = postFiles[i]
        let suffix = this.getFileSuffix(file.name)
        let localUrl = URL.createObjectURL(file)
        let uuid = uuidv1()
        let fileTypeName = this.$getFileType(file.name)
        let fileType = this.getFileRelType(fileTypeName)
        let prefix = this.getUploadPrefix(fileTypeName)
        let uploadPath = prefix + uuid + suffix
        let width = 0
        let height = 0
        if (fileType === 1) {
          let obj = await this.getImgInfo(file)
          width = obj.width
          height = obj.height
        }
        resultArray.push({
          id: 0,
          oldName: file.name || '',
          localfile: file,
          localUrl: localUrl,
          uploadPath: uploadPath,
          fileType: fileType,
          suffix: suffix,
          url: '',
          progress: 0,
          uploadResult: 0,//0:未上传 1：上传成功   2：上传失败
          width: width,
          height: height
        })
      }
      this.$emit('uploadStart', resultArray)
      resultArray.forEach(uploadObj => {
        this.upload(uploadObj).then(res => {
          let finishiLength = resultArray.filter(child => {
            return child.uploadResult === 1 || child.uploadResult === 2
          })
          let progressData = {
            finishNum: finishiLength.length,
            totalNum: resultArray.length
          }
          this.$emit('uploadProgress', progressData)
          if (finishiLength.length === resultArray.length) {
            this.$emit('uploadSuccess', resultArray)
          }
        })
      })
    },
    upload (uploadObj) {
      if (uploadObj.fileType === 1) {
        return new ossupload.PicOss().multipartUpload(uploadObj.uploadPath, uploadObj.localfile, (data) => {
          uploadObj.progress = Number.parseInt(data * 100)
        }).then(r1 => {
          let domain = isOnLine ? onlineOssInfo.url : underlineOssInfo.url
          uploadObj.progress = 100
          uploadObj.uploadResult = 1
          uploadObj.url = 'http://' + domain + '/' + r1.url
        }, () => {
          uploadObj.uploadResult = 2
        })
      } else if (uploadObj.fileType === 2) {
        return new ossupload.VideoOss().multipartUpload(uploadObj.uploadPath, uploadObj.localfile, (data) => {
          uploadObj.progress = Number.parseInt(data * 100)
        }).then(r1 => {
          let domain = isOnLine ? videoOnlineOssInfo.url : videoUnderlineOssInfo.url
          uploadObj.progress = 100
          uploadObj.uploadResult = 1
          uploadObj.url = 'http://' + domain + '/' + r1.url
          uploadObj.videoUrl = 'http://' + domain + '/' + r1.url
        }, () => {
          uploadObj.uploadResult = 2
        })
      } else {
        return new ossupload.FileOss().multipartUpload(uploadObj.uploadPath, uploadObj.localfile, (data) => {
          uploadObj.progress = Number.parseInt(data * 100)
        }).then(r1 => {
          let domain = isOnLine ? fileOnlineOssInfo.url : fileUnderlineOssInfo.url
          uploadObj.progress = 100
          uploadObj.uploadResult = 1
          uploadObj.url = 'http://' + domain + '/' + r1.url
        }, () => {
          uploadObj.uploadResult = 2
        })
      }
    },
    getImgInfo (item) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(item)
        reader.onload = function () {
          const img = new Image()
          img.src = reader.result
          let width = 0
          let height = 0
          if (img.complete) {
            width = img.width
            height = img.height
            resolve({
              width,
              height
            })
          } else {
            img.onload = function () {
              width = img.width
              height = img.height
              resolve({
                width,
                height
              })
            }
          }
        }
      })
    },
    getFileSuffix (name) {
      let resultstr = ''
      let index = name.lastIndexOf('.')
      if (index > 0) {
        resultstr = name.substring(index)
      }
      return resultstr
    },
    getFileRelType (fileTypeName) {
      let realType = 50
      if (fileTypeName === 'image') {
        realType = 1
      } else if (fileTypeName === 'video') {
        realType = 2
      } else if (fileTypeName === 'word') {
        realType = 3
      } else if (fileTypeName === 'excel') {
        realType = 4
      } else if (fileTypeName === 'ppt') {
        realType = 5
      } else if (fileTypeName === 'pdf') {
        realType = 6
      }
      return realType
    },
    getUploadPrefix (fileTypeName) {
      let uploadPath = ''
      switch (fileTypeName) {
        case 'image':
          uploadPath = (isOnLine ? '' : 'image/') + projectName + '/' + this.prefix
          break
        case 'video':
          uploadPath = projectName + '/' + this.videoprefix
          break
        case 'audio':
          uploadPath = (isOnLine ? '' : 'audio/') + projectName + '/common/desc/'
          break
        case 'word':
          uploadPath = (isOnLine ? '' : 'file/') + projectName + '/common/word/'
          break
        case 'ppt':
          uploadPath = (isOnLine ? '' : 'file/') + projectName + '/common/ppt/'
          break
        case 'pdf':
          uploadPath = (isOnLine ? '' : 'file/') + projectName + '/common/pdf/'
          break
        case 'excel':
          uploadPath = (isOnLine ? '' : 'file/') + projectName + '/common/excel/'
          break
        default:
          uploadPath = (isOnLine ? '' : 'file/') + projectName + '/common/common/'
          break
      }
      return uploadPath
    }
  }
}
</script>

<style lang="scss" scoped>
  .input-style {
    display: none;
  }
</style>
